"use client"

import { usePathname } from "next/navigation"
import { Footer } from "./footer"

export default function FooterWrapper() {
  const pathname = usePathname()
  if (pathname?.startsWith("/chat")) return null
  if (pathname?.startsWith("/admin")) return null
  if (pathname?.startsWith("/offer-seats")) return null
  return <Footer />
}
